<template>
  <div class="comment-holder">
    <button class="badge badge-info comment-toggle" :style="badgeStyle" @click.prevent="visible = !visible">
      <i class="glyphicon glyphicon-comment"></i>
    </button>

    <div class="comments" v-show="visible">
      <dl class="previous-years-comments" v-if="lastYearCommentValue">
        <dt>Previous years comments</dt>
        <dd class="text-block" v-html="lastYearCommentValue"></dd>
      </dl>
      <dl>
        <dt>Current comments</dt>
        <dd>
          <textarea
            type="text"
            v-model.lazy="currentCommentValue"
            class="form-control"
            :disabled="isReadOnly"
            @input="resizeTextarea"
            ref="resizabletextarea"
          >
          </textarea>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { prefixedField } from '@/_helpers/utils'

export default {
  props: {
    farmId: {
      type: Number,
      required: false,
    },
    fieldName: {
      type: String,
      required: true,
    },
    fieldPrefix: {
      type: String,
      required: false,
    },
    modelName: {
      type: String,
      required: false, // uses current-step's model as modelName
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  watch: {
    visible: function (value) {
      if (value) this.resizeTextarea()
    },
  },
  mounted() {
    this.visible = this.hasComments
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldComment']),
    resizeTextarea() {
      let textarea = this.$refs.resizabletextarea
      this.$nextTick(() => {
        textarea.style.height = 'auto'
        textarea.style.height = `${textarea.scrollHeight}px`
      })
    },
    prefixedField: prefixedField,
  },
  computed: {
    ...mapGetters('currentConsult', ['isReadOnly', 'getFieldComment']),
    isFarmComment: function () {
      return Boolean(this.farmId)
    },
    getFieldName: function () {
      return this.isFarmComment ? this.prefixedField(this.fieldName, this.farmId, this.fieldPrefix) : this.fieldName
    },
    hasComments() {
      return this.lastYearCommentValue || this.currentCommentValue
    },
    badgeStyle() {
      return { background: this.hasComments ? '#009900' : '#337ab7' }
    },
    lastYearCommentValue() {
      return this.getFieldComment(this.getFieldName, this.modelName).lastYear
    },
    currentCommentValue: {
      get() {
        return this.getFieldComment(this.getFieldName, this.modelName).current
      },
      set(val) {
        let payload = { fieldName: this.getFieldName, modelName: this.modelName, value: val }

        this.setFieldComment(payload)
        this.$emit('on-change', payload)
      },
    },
  },
}
</script>

<style type="text/css" media="screen">
.comment-holder {
  display: inline;
  margin-left: 40px;
  position: relative;
}
.comment-holder .comment-toggle {
  position: absolute;
  float: right;
  top: 0;
  right: 0;
}
.comments dt, dd {
  font-size: 14px;
}

.text-block {
  white-space: pre-line;
}

.previous-years-comments {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  padding: 5px 10px;
}
</style>
